module.exports = __webpack_public_path__ + "assets/img/lesson_video.f0ff9a49.png";